import { useEffect, useRef } from "react";
import WaveSurfer from "wavesurfer.js";

const WaveformPlayer = ({ url, isActive, onPlay, onFinish }) => {
  const containerRef = useRef(null);
  const waveRef = useRef(null);
  const isReadyRef = useRef(false);

  // Create WaveSurfer ONCE
  useEffect(() => {
    if (!containerRef.current || waveRef.current) return;

    const wave = WaveSurfer.create({
      container: containerRef.current,
      waveColor: "#6B7280",
      progressColor: "#FFFFFF",
      cursorColor: "#FA6138",
      height: 32,
      barWidth: 2,
      barGap: 2,
      normalize: true,
      responsive: true
    });

    waveRef.current = wave;

    wave.on("ready", () => {
      isReadyRef.current = true;
    });

    wave.on("finish", () => {
      onFinish?.();
    });

    wave.on("error", (err) => {
      // ✅ Ignore abort errors safely
      if (err?.name === "AbortError") return;
      console.error("WaveSurfer error:", err);
    });

    wave.load(url);

    return () => {
      isReadyRef.current = false;
      wave.destroy();
      waveRef.current = null;
    };
  }, [url, onFinish]);

  // Control playback without reloading
  useEffect(() => {
    const wave = waveRef.current;
    if (!wave || !isReadyRef.current) return;

    if (isActive) {
      wave.play();
    } else {
      wave.pause();
      wave.seekTo(0);
    }
  }, [isActive]);

  return (
    <div
      ref={containerRef}
      className="w-full h-[32px] cursor-pointer"
      onClick={onPlay}
    />
  );
};

export default WaveformPlayer;
